(function() {
  const videoButton = document.querySelector('.wideVideoModule__button'),
        videoSection = document.querySelector('.wideVideoModule'),
        popupVideos = document.querySelectorAll('.wideVideoModule__popupWrapper video');

  function openVideo() {
    videoSection.classList.add('wideVideoModule--active');
    if (popupVideos.length > 1) {
      if (window.innerWidth <= 768) {
        let mobileVideo = document.querySelector('.wideVideoModule__popup--mobile');

        mobileVideo.play();
      } else {
        let desktopVideo = document.querySelector('.wideVideoModule__popup--desktop');

        desktopVideo.play();
      }
    } else {
      popupVideos.forEach(video => {
        video.play();
      });
    }
  }

  videoButton.addEventListener('click', openVideo);
})();
